module.exports = [{"name":"yarhp","description":"All the best aggregators in one spot","url":"https://yarhp.com"},{"name":"bins.io","description":"Bins.io is a file sharing tool usable from anywhere with bash.","url":"https://bins.io"},{"name":"git.gg","description":"Yet another GitLab deployment","url":"https://git.gg"},{"name":"Parkpage","description":"<meta> the project that powers this page.","url":"https://github.com/chpwssn/parkpage"}]


//////////////////
// WEBPACK FOOTER
// ./src/config/projects.json
// module id = 36
// module chunks = 0